export const CHANGE_SP_WORKER_GENERAL_INFO = 'CHANGE_SP_WORKER_GENERAL_INFO';
export const CHANGE_SP_WORKER_CHOSEN_SERVICES = 'CHANGE_SP_WORKER_CHOSEN_SERVICES';
export const CHANGE_SP_WORKER_CHOSEN_CERTIFICATE = 'CHANGE_SP_WORKER_CHOSEN_CERTIFICATE';
export const CHANGE_SP_WORKER_AVATAR = 'CHANGE_SP_WORKER_AVATAR';
export const REGISTER_SERVICE_PROVIDER_WORKER = 'REGISTER_SERVICE_PROVIDER_WORKER';
export const CLEAR_SP_WORKER_REGISTRATION_DATA = 'CLEAR_SP_WORKER_REGISTRATION_DATA';
